/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { PraticaAnagraficaUpdateForm } from '../model/models';
import { PraticaAttributiBulkUpdateForm } from '../model/models';
import { PraticaComponenteCreateForm } from '../model/models';
import { PraticaComponenteUpdateForm } from '../model/models';
import { PraticaOperatoreDetailDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AggiornaPraticaComponenteRequestParams {
    idTipoPratica: string;
    idPratica: string;
    idComponente: string;
    praticaComponenteUpdateForm: PraticaComponenteUpdateForm;
}

export interface AggiungiPraticaComponenteRequestParams {
    idTipoPratica: string;
    idPratica: string;
    praticaComponenteCreateForm: PraticaComponenteCreateForm;
}

export interface DisabilitaPraticaComponenteRequestParams {
    idTipoPratica: string;
    idPratica: string;
    idComponente: string;
    version: number;
    mode?: 'PRESA_IN_CARICO' | 'AGGIORNA' | 'SOVRASCRIVI_ORIGINALE';
}

export interface PatchPraticaAnagraficaRequestParams {
    idTipoPratica: string;
    idPratica: string;
    praticaAnagraficaUpdateForm: PraticaAnagraficaUpdateForm;
}

export interface PatchPraticaAttributiRequestParams {
    idTipoPratica: string;
    idPratica: string;
    praticaAttributiBulkUpdateForm: PraticaAttributiBulkUpdateForm;
}


export interface GestionePraticheEditDatiServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * PATCH parziale componente nucleo (chiave-driven). Body: {form_data: {chiave: val}, assegnazione_scolastica_id?, abilitato?, modes?, version}. Campi-attributo in form_data (reset-a-null su chiave presente con null); strutturali fuori. Supporta re-enable via abilitato&#x3D;true. Response: 200, 400/403/404 (componente non appartiene 404), 409, 422 (chiave sconosciuta/obbligatoria/constraint/gate o cross-bando assegnazione).
     * 
     * @endpoint patch /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/componenti/{idComponente}
* @param requestParameters
     */
    aggiornaPraticaComponente(requestParameters: AggiornaPraticaComponenteRequestParams, extraHttpRequestParams?: any): Observable<PraticaOperatoreDetailDTO>;

    /**
     * Aggiunge componente al nucleo familiare (chiave-driven). Body: {form_data: {chiave: val}, assegnazione_scolastica_id?, mode?, version}. Campi-attributo in form_data keyed by chiave (target&#x3D;NUCLEO_FAMILIARE_COMPONENTE); strutturali fuori. assegnazione_scolastica_id (opzionale) deve appartenere al bando. Response: 201 + detail, 422 (chiave sconosciuta/obbligatoria mancante/constraint).
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/componenti
* @param requestParameters
     */
    aggiungiPraticaComponente(requestParameters: AggiungiPraticaComponenteRequestParams, extraHttpRequestParams?: any): Observable<PraticaOperatoreDetailDTO>;

    /**
     * Soft-disable componente nucleo (setta abilitato&#x3D;false, NO DB delete). RICHIEDENTE bloccato 422. Idempotente su componenti gia\&#39; disabilitati. Re-enable via PATCH /componenti/{idC} {abilitato: true}. Response: 204 No Content.
     * 
     * @endpoint delete /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/componenti/{idComponente}
* @param requestParameters
     */
    disabilitaPraticaComponente(requestParameters: DisabilitaPraticaComponenteRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * PATCH parziale anagrafica chiave-driven. Body: {form_data: {chiave: val}, version}, keyed by TipoPraticaAttributo.chiave (target&#x3D;ANAGRAFICA_RICHIEDENTE). Chiave presente con null &#x3D; reset (se opzionale); chiave assente &#x3D; no-op. CF change triggera conflict detector + auto-update componente RICHIEDENTE. Hard-coded SOVRASCRIVI_ORIGINALE (niente mode). Response: 200 OK, 400/403/404, 409 conflict/optimistic lock, 422 (chiave sconosciuta/obbligatoria mancante/constraint/gate).
     * 
     * @endpoint patch /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/anagrafica
* @param requestParameters
     */
    patchPraticaAnagrafica(requestParameters: PatchPraticaAnagraficaRequestParams, extraHttpRequestParams?: any): Observable<PraticaOperatoreDetailDTO>;

    /**
     * PATCH chiave-driven 3-target (PRATICA/ANAGRAFICA/COMPONENTE). Body: {pratica: {chiave: val}, anagrafica: {chiave: val}, componente: {idC: {chiave: val}}, modes_pratica?, modes_componente?, version}. Ogni chiave instradata via binding_target: system-con-nativo fa mirror sulla colonna + EAV; custom solo EAV. Codice ANPR &#x3D; chiave del target PRATICA. Reset-a-null su chiave presente con null. Anagrafica hard-coded SOVRASCRIVI (niente modes_anagrafica). Response: 200, 400/403/404, 409, 422 (chiave sconosciuta/target mismatch/obbligatoria mancante/constraint).
     * 
     * @endpoint patch /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/attributi
* @param requestParameters
     */
    patchPraticaAttributi(requestParameters: PatchPraticaAttributiRequestParams, extraHttpRequestParams?: any): Observable<PraticaOperatoreDetailDTO>;

}
